import { combineReducers } from '@reduxjs/toolkit'
import { reducer as bottomNavReducer } from './BottomNav'
import { reducer as bottomNavDraftReducer } from './BottomNav/Draft'
import { reducer as hamburgerNavReducer } from './HamburgerNav'
import mainSlice from './main'
import { reducer as styleReducer } from './Style'

// Combine all reducers including the main state
export const reducer = combineReducers({
  main: mainSlice.reducer,
  style: styleReducer,
  hamburgerNav: hamburgerNavReducer,
  bottomNav: bottomNavReducer,
  bottomNavDraft: bottomNavDraftReducer,
})

// Export actions
export const { showConfirmModal, hideConfirmModal, setFormValid } =
  mainSlice.actions
